import compose from 'recompose/compose';
import withHandlers from 'recompose/withHandlers';
import { connect } from 'react-redux';
import ChairRentalListItem from '../components/ChairRentalListItem';
import withToggle from '../../../../common/hoc/withToggle';
import confirmModal from '../../../../common/confirmModal';
import { saveChairRental } from '../actions';

const mapDispatchToProps = {
  saveChairRental,
};

const ChairRentalListItemContainer = compose(
  connect(null, mapDispatchToProps),
  withToggle('modal'),
  withHandlers({
    toggleEnabled: props => (e) => {
      const { chairRental } = props;

      if (!chairRental.enabled) {
        return;
      }

      e.stopPropagation();
      const name = `${chairRental.barber.firstName} ${chairRental.barber.lastName}`;

      confirmModal({
        title: 'Turn off auto rent charge',
        message: `Are you sure you want to turn off auto rent charge for ${name}?`,
        type: 'yesno',
        confirmButtonText: 'Yes',
        negativeButtonText: 'No',
      },
      () => props.saveChairRental(chairRental.barberId, { enabled: false })
        .then(() => props.modalOff())
        .catch(() => props.modalOff()),
      () => props.modalOff()
      );
    },
  })
)(ChairRentalListItem);

export default ChairRentalListItemContainer;
